import { defaultInitialState } from '../utils';
import { UNSUBSCRIBE_REQUEST, UNSUBSCRIBE_REQUEST_DONE, UNSUBSCRIBE_REQUEST_ERROR, UNSUBSCRIBE_REQUEST_RESET } from './actionTypes';
const initialState = defaultInitialState;
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case UNSUBSCRIBE_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: false, errorMessage: null });
        case UNSUBSCRIBE_REQUEST_DONE:
            return Object.assign(Object.assign({}, state), { isUpdated: true, isLoading: false, error: false, errorMessage: null });
        case UNSUBSCRIBE_REQUEST_ERROR:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: true, errorMessage: action.data.msg });
        case UNSUBSCRIBE_REQUEST_RESET:
            return initialState;
        default:
            return state;
    }
};
export default reducer;
//# sourceMappingURL=reducer.js.map